import { pointOfSaleApi } from '@repo/api-client';
import { useRevalidator } from 'react-router';
import { Button } from '@repo/ui/components/button';
import { Input } from '@repo/ui/components/form/input';
import { useForm } from '@repo/ui/hooks/use-form';
import { useAsync } from '@repo/ui/hooks/use-async';
import { useCurrentClub } from '@/hooks/use-current-club';

export function CreatePosForm({ onClose }: { onClose: () => void }) {
  const revalidator = useRevalidator();
  const club = useCurrentClub();

  const { execute: onSubmit, loading } = useAsync(async () => {
    await pointOfSaleApi.create(club.id, values);
    revalidator.revalidate();
    onClose();
  });

  const { ref, values, errors } = useForm({
    initialValues: {
      name: '',
      description: '',
    },
    onSubmit,
  });

  return (
    <div className="flex justify-center w-full">
      <form ref={ref} className="w-full flex flex-col gap-4">
        <Input label="Nombre" type="text" name="name" required errors={errors} />
        <Input label="Descripción" type="text" name="description" required errors={errors} />
        <Button type="submit" loading={loading}>
          Crear
        </Button>
      </form>
    </div>
  );
}
